



































import Vue from 'vue';

export default Vue.extend({
    name: 'login-button',
    props: {
        uid: { type: String, required: false },
        displayName: { type: String, required: false },
    },
});
